export default "<p>admin-historial works!</p>\n";